import { goSolidApi } from "@/composables/useGoSolidApi";
import type {
  ApiKey,
  CreateApiKeyRequest,
  CreateApiKeyResponse,
} from "./apiKeysTypes";

export const apiKeysApi = {
  /**
   * Fetch all API keys
   * @returns Promise resolving to array of API keys
   * @throws Error if request fails
   */
  list: async (): Promise<ApiKey[]> => {
    const response = await goSolidApi.get<ApiKey[]>("/api/admin/api-keys");
    return response.data;
  },

  /**
   * Create a new API key
   * @param payload - The API key creation request
   * @returns Promise resolving to created API key and plaintext key
   * @throws Error if request fails
   */
  create: async (
    payload: CreateApiKeyRequest
  ): Promise<CreateApiKeyResponse> => {
    const response = await goSolidApi.post<CreateApiKeyResponse>(
      "/api/admin/api-keys",
      payload
    );
    return response.data;
  },

  /**
   * Revoke an existing API key
   * @param id - The API key ID to revoke
   * @returns Promise resolving when revocation is complete
   * @throws Error if request fails
   */
  revoke: async (id: number): Promise<void> => {
    await goSolidApi.delete(`/api/admin/api-keys/${id}`);
  },
};
